export enum SocialCategories {
    TSArecipients = 'TSArecipients',
    pensioners = 'pensioners',
    largeFamilies = 'largeFamilies',
    firstGroupDisabled = 'firstGroupDisabled',
    secondGroupDisabled = 'secondGroupDisabled',
    thirdGroupDisabled = 'thirdGroupDisabled',
    SocialCategories = "SocialCategories",
    disabled = "disabled",
}

export enum EmploymentCategories {
    hired_budget = 'hired_budget',
    hired_private = 'hired_private',
    selfEmployed = 'selfEmployed',
    unemployed = 'unemployed',
    workingElderly = 'workingElderly',
}

export interface IScreeningFarming {
    animalHusbandry: IFarmingItemsList,
    agriculturalGrowth: {
        KPC: { year: number, value: string }[],
        MPC: { year: number, value: string }[],
        horses: { year: number, value: string }[],
        birds: { year: number, value: string }[],
        camels: { year: number, value: string }[],
    },
    selfSufficiency: {
        sheep: string,
        bird: string,
        egg: string,
        cucumber: string,
        tomato: string,
    },
    poultry: IPoultryList,
    meat: IFarmingItemsList,
    milk: {
        dairy: string,
        milkProduction: string,
    },
    cropArea: {
        kh: IFarmingAreaItem,
        lph: IFarmingAreaItem,
    },
    yearlyMeat: IFarmingItemsList,
    milkProduction: {
        butter: {
            yearly: string,
            average: string,
        },
        cottage: {
            yearly: string,
            average: string,
        },
        sourCream: {
            yearly: string,
            average: string,
        },
        kefir: {
            yearly: string,
            average: string,
        },
        milk: {
            yearly: string,
            average: string,
        }
    },
    harvest: {
        kh: IFarmingAreaItem,
        lph: IFarmingAreaItem,
    }
}


export interface IScreeningInfo {
    humanResources: IHumanResources | null,
    landFund: ILandFund | null,
    smbDevelopment: IMCB | null,
    swotAnalysis: ISWOT | null,
    agriculture: IScreeningFarming | null,
}

export interface IHumanResources {
    populationDynamic: IScreeningPopulationDynamic[] | null,
    populationByAge: IScreeningPopulationByAge[] | null,
    employment: IScreeningEmployment | null,
    populationBySocialStatus: IScreeningPopulationbySocialStatus | null,
}

export interface IScreeningPopulationDynamic {
    year: number,
    population: number,
}

export interface IScreeningPopulationByAge {
    age: '0-5' | '6-17' | '18-29' | '30-62' | '63 и старше',
    population: number,
}

interface IScreeningEmployment {
    [EmploymentCategories.hired_budget]: number,
    [EmploymentCategories.hired_private]: number,
    [EmploymentCategories.selfEmployed]: number,
    [EmploymentCategories.unemployed]: number,
    [EmploymentCategories.workingElderly]: number,
}

interface IScreeningPopulationbySocialStatus {
    [SocialCategories.TSArecipients]: number,
    [SocialCategories.pensioners]: number,
    [SocialCategories.largeFamilies]: number,
    [SocialCategories.firstGroupDisabled]: number,
    [SocialCategories.secondGroupDisabled]: number,
    [SocialCategories.thirdGroupDisabled]: number,
}

export interface ILandFund {
    largeLandowners: ILargeLandowners[] | null,
    landFundItems: ILandFundItem | null
}

export interface ILargeLandowners {
    name: string,
    total_land: number,
    total_arable: number,
    total_pasture: number,
    fact_land: number,
    fact_arable: number,
    fact_pasture: number,
}

export interface ILandFundItem {
    settlementLand: string,
    agricultural_total: string,
    agricultural_arable: string,
    agricultural_pasture: string,
    agricultural_farmEnterprises: string,
    reserve_total: string,
    reserve_arable: string,
    reserve_pasture: string,
    otherLand: string
}

export interface IMCB {
    mcbSubjects: IScreeningMCBSubjects | null,
    registeredSubjects: IScreeningRegisteredSubjects | null,
    totalSum: string | number,
    creditSupport: IScreeningMCBCreditSupport | null,
}

export interface IScreeningMCBSubjects {
    total: string,
    TOO: string,
    IP: string,
    KH: string,
    SPK: string,
}

export interface IScreeningRegisteredSubjects {
    juridical: string,
    agricultural: string,
    construction: string,
    retail: string,
    printing: string,
    finance: string,
    commerce: string,
    [key: string]: any,
}

export interface IScreeningMCBCreditSupport {
    subsidizing_projects: string,
    subsidizing_sum: string,
    guarantee_projects: string,
    guarantee_sum: string,
    grant_projects: string,
    grant_sum: string,
}

export interface ISWOT {
    strengths: ISWOTItem[] | null,
    weaknesses: ISWOTItem[] | null,
    opportunities: ISWOTItem[] | null,
    threats: ISWOTItem[] | null,
}

export interface ISWOTItem {
    textRu: string,
    textKz: string,
}

export interface IFarmingAreaItem {
    vegetables: string,
    grains: string,
    potato: string,
    carnival: string,
    forage: string,
}

export interface IFarmingItemsList {
    KPC: IFarmingItem,
    MPC: IFarmingItem,
    horses: IFarmingItem,
    camels: IFarmingItem,
}

export interface IPoultryList {
    goose: IFarmingItem,
    duck: IFarmingItem,
    chicken: IFarmingItem,
}

export interface IFarmingItem {
    lph: string,
    kh: string,
}

